import { render } from "./StackItem.vue?vue&type=template&id=83022996&scoped=true&ts=true"
import script from "./StackItem.vue?vue&type=script&lang=ts"
export * from "./StackItem.vue?vue&type=script&lang=ts"

import "./StackItem.vue?vue&type=style&index=0&id=83022996&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83022996"]])

export default __exports__